<template>
  <v-dialog
    v-model="show"
    max-width="1000"
    @click:outside="cancel"
    @keydown.esc="cancel">
    <v-card
      v-if="show">
        <v-toolbar short dark color="primary">
          <v-btn icon dark @click="cancel">
              <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
              {{$t("common.search")}}
          </v-toolbar-title>
          <template v-slot:extension>
            <v-tabs v-model="modelTab">
              <v-tab
                v-for="item in modelTabs"
                :key=item
                :href="'#'+item"
              >{{ item === "Transport event" ? "Matkatapahtuma" : item }}</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card-text>
          <v-tabs-items v-model="modelTab">
            <v-tab-item key="Likuma" value="Likuma">
                  <LikumaRangeSearchForm
                    :searchParams="searchParams"
                    ref=likumaRangeSearchForm
                  ></LikumaRangeSearchForm>
            </v-tab-item>
            <v-tab-item key="Kela" value="Kela">
                  <KelaRangeSearchForm
                    :searchParams="searchParams"
                    ref=kelaRangeSearchForm
                  ></KelaRangeSearchForm>
            </v-tab-item>
            <v-tab-item key="Kaista" value="Kaista">
                  <KaistaRangeSearchForm
                    :searchParams="searchParams"
                    ref=kaistaRangeSearchForm
                  ></KaistaRangeSearchForm>
            </v-tab-item>
            <v-tab-item key="Transport event" value="Transport event">
                  <TransportEventRangeSearchForm
                    :searchParams="searchParams"
                    ref="transportEventRangeSearchForm"
                  ></TransportEventRangeSearchForm>
                </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              autofocus
              color="primary"
              @click="search">
              {{$t("common.search")}}
            </v-btn>
            <v-btn
              color="secondary"
              @click="reset"
              class="ml-2">
              {{$t("common.reset")}}
            </v-btn>
            <v-btn
              @click="cancel"
              class="ml-2">
              {{$t("common.close")}}
            </v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import TransportEventRangeSearchForm from "./SearchParamForms/TransportEventRangeSearchForm";
import LikumaRangeSearchForm from "./SearchParamForms/LikumaRangeSearchForm";
import KelaRangeSearchForm from "./SearchParamForms/KelaRangeSearchForm";
import KaistaRangeSearchForm from "./SearchParamForms/KaistaRangeSearchForm";
import _ from "lodash";
import moment from "moment";

export default {
    props: {
        show: Boolean,
        params: Object
    },
    components: {
        TransportEventRangeSearchForm,
        LikumaRangeSearchForm,
        KelaRangeSearchForm,
        KaistaRangeSearchForm
    },
    data() {
        return {
            searchParams: this.formatSearchParams(this.params),
            modelTab: 0
        };
    },
    computed: {
        modelTabs() {
            if (this.$store.state.user.tenant === "ltx") {
                return ["Likuma", "Transport event"];
            }
            if (this.$store.state.user.tenant === "taksikuutio" || this.$store.state.user.tenant === "pst-kela") {
                return ["Kela", "Transport event"];
            }
            if (this.$store.state.user.tenant === "kaista") {
                return ["Kaista", "Transport event"];
            }
            return ["Transport event", "Likuma", "Kela"];
        }
    },
    watch: {
        params(val) {
            this.searchParams = this.formatSearchParams(val);
        }
    },
    methods: {
        search() {
            let form = this.getActiveForm();
            if (!form) return;
            let params = _.cloneDeep(form.getSearchParameters());
            if (params.modifiedFrom) {
                params.modifiedFrom = moment(params.modifiedFrom).format();
            }
            if (params.modifiedTo) {
                params.modifiedTo = moment(params.modifiedTo).format();
            }
            if (params.tripStartedFrom) {
                params.tripStartedFrom = moment(params.tripStartedFrom).format();
            }
            if (params.tripStartedTo) {
                params.tripStartedTo = moment(params.tripStartedTo).format();
            }
            if (params.tripEndedFrom) {
                params.tripEndedFrom = moment(params.tripEndedFrom).format();
            }
            if (params.tripEndedTo) {
                params.tripEndedTo = moment(params.tripEndedTo).format();
            }
            this.$emit("search", params);
        },
        cancel() {
            this.searchParams = this.formatSearchParams(this.params);
            this.$emit("close");
        },
        reset() {
            this.searchParams = {};
            let activeForm = this.getActiveForm();
            if (activeForm && activeForm.reset) {
                activeForm.reset();
            }
        },
        getActiveForm() {
            if (this.modelTab === "Likuma") {
                return this.$refs.likumaRangeSearchForm;
            }
            if (this.modelTab === "Kela") {
                return this.$refs.kelaRangeSearchForm;
            }
            if (this.modelTab === "Kaista") {
                return this.$refs.kaistaRangeSearchForm;
            }
            if (this.modelTab === "Transport event") {
                return this.$refs.transportEventRangeSearchForm;
            }
            return null;
        },
        formatSearchParams(params) {
            let searchParams = params ? _.cloneDeep(params) : {};
            if (searchParams.modifiedFrom) {
                searchParams.modifiedFrom =
                  moment(searchParams.modifiedFrom).format("YYYY-MM-DD");
            }
            if (searchParams.modifiedTo) {
                searchParams.modifiedTo =
                  moment(searchParams.modifiedTo).format("YYYY-MM-DD");
            }
            if (searchParams.tripStartedFrom) {
                searchParams.tripStartedFrom =
                  moment(searchParams.tripStartedFrom).format("YYYY-MM-DD");
            }
            if (searchParams.tripStartedTo) {
                searchParams.tripStartedTo =
                   moment(searchParams.tripStartedTo).format("YYYY-MM-DD");
            }
            if (searchParams.tripEndedFrom) {
                searchParams.tripEndedFrom =
                  moment(searchParams.tripEndedFrom).format("YYYY-MM-DD");
            }
            if (searchParams.tripEndedTo) {
                searchParams.tripEndedTo =
                  moment(searchParams.tripEndedTo).format("YYYY-MM-DD");
            }
            return searchParams;
        }
    }

};
</script>

<style scoped>
.v-subheader {
  height: 1em;
  margin-top: 0.1em;
}
</style>
